import logoFull from "@/assets/watts-logo.png";
import logoMark from "@/assets/watts-mark.png";

interface Props {
  /** Rendered height in px. Width auto, aspect ratio preserved. Ignored if `width` is set. */
  size?: number;
  /** Rendered width in px. Height auto, aspect ratio preserved. Takes precedence over `size`. */
  width?: number;
  /** "full" → wordmark + tagline. "icon" → pin mark only. */
  variant?: "full" | "icon";
  className?: string;
}

export function WattsLogo({ size = 28, width, variant = "full", className = "" }: Props) {
  const src = variant === "icon" ? logoMark : logoFull;
  const style: React.CSSProperties = width
    ? { width, height: "auto", objectFit: "contain", display: "block" }
    : { height: size, width: "auto", objectFit: "contain", display: "block" };
  return (
    <img
      src={src}
      alt="Watts"
      style={style}
      className={className}
      draggable={false}
    />
  );
}
